import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import CardActions from '@mui/material/CardActions';
import Typography from '@mui/material/Typography';
import LockIcon from '@mui/icons-material/Lock';

import { generateImageUrl } from 'shared/functions';

const useStyles = makeStyles(() => ({
  footer: {
    fontWeight: 500,
    marginLeft: 8,
  },
  lock: {
    marginLeft: 'auto',
    marginRight: 8,
  },
  card: {
    paddingBottom: 0,
  },
}));

const NewsCard = ({ onClick, title, teaser, footer, imgUrl, restricted, source }) => {
  const classes = useStyles();

  return (
    <Card onClick={onClick}>
      <CardActionArea>
        {imgUrl && (
          <CardMedia
            component="img"
            alt={title}
            image={generateImageUrl(imgUrl, source)}
            title={title}
          />
        )}
        <CardContent className={classes.card}>
          <Typography gutterBottom variant="h5" component="h2">
            {title}
          </Typography>
          <Typography variant="body2" color="textSecondary" component="p">
            {teaser}
          </Typography>
        </CardContent>
        <CardActions disableSpacing>
          <Typography
            className={classes.footer}
            variant="body2"
            color="textSecondary"
            component="p"
          >
            {footer}
          </Typography>
          {restricted && <LockIcon className={classes.lock} />}
        </CardActions>
      </CardActionArea>
    </Card>
  );
};

NewsCard.defaultProps = {
  title: null,
  teaser: null,
  footer: null,
  imgUrl: null,
  restricted: false,
  source: null,
};

NewsCard.propTypes = {
  title: PropTypes.string,
  teaser: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  footer: PropTypes.string,
  imgUrl: PropTypes.string,
  restricted: PropTypes.bool,
  source: PropTypes.string,
};

export default NewsCard;
